import { Avatar, Paper, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { PurpleAlert } from 'Images';

export const FirstSegment = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Equipment);

  return (
    <Paper
      elevation={0}
      sx={{
        border: '1px solid',
        borderColor: 'primary.shade_200',
        bgcolor: 'primary.shade_50',
        borderRadius: '12px',
        p: '24px',
      }}
    >
      <Stack direction='row' alignItems='center' columnGap='8px'>
        <Avatar
          sx={{ height: '24px', width: '24px' }}
          src={PurpleAlert}
          alt=''
        />
        <Typography component='h2' variant='body2'>
          {
            dictionary.youHaveNotBeenApprovedYetToOrderEquipmentYouMustRequestEligibility
          }
        </Typography>
      </Stack>
    </Paper>
  );
};
